// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RwaQ","select":"styles_select__AyRkV"};